import { GrispiInputProps } from '..';
import GrispiAutoCompleteInput, { AutoCompleteKeyMap } from './GrispiAutoCompleteInput';

type GrispiFormInputProps = Omit<GrispiInputProps<'FORM'>, 'type'>;

const GrispiFormInput = (props: GrispiFormInputProps) => {
    const { isEndUserForm, ...rest } = props;
    const autocompleteKey = isEndUserForm ? AutoCompleteKeyMap.endUserForm : AutoCompleteKeyMap.form;
    return <GrispiAutoCompleteInput {...rest} autocompleteKey={autocompleteKey} />;
};

export default GrispiFormInput;
